export function characterGroups(characters) {
  const all = Object.values(characters || {}).filter(character => character?.on_screen === true);
  return { all, npcs: all.filter(character => character.npc === true), players: all.filter(character => character.npc === false) };
}
